module.exports = __webpack_public_path__ + "img/ro.8b7394c0.svg";